import React, { Component } from "react";

import ProjPeopleContent from "../../ProjPeopleContent";

import colors from "../../colors";
// import menu from "../data/data";//menu
import Slider from "./Slider";

const projTeam = {
  header: [
    "Deputy Project Director",
    "Principal Investigator",
    "Co-investigators",
    "Team Lead",
    "Team Members",
    "Research Scientists",
    "Research Fellows",
  ],
  rows: {
    row1: [
      "Dr. K.H.V. DurgaRao, Head, DMSD",
      "Sri.  Amanpreet  Singh, S/E  'SD', DMSD",
      "Sri. Abinav kumar Shukla, S/E 'SD', DMSD",
      "",
      "",
      "Sri. Shubham Shaurabh (WR)",
      "Ms. K Sindhu SRF (RS&GIS)",
    ],
    // row2:["", "", "", "", "", "Sri. Shubham Shaurabh (WR)", "Ms. K Sindhu SRF (RS&GIS)"]
  },
};
export default class FLProjTeam extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />

          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div className="card" style={{ width: "100%", height: "100%" }}>
              <div className="card-body">
                <ProjPeopleContent data={projTeam} width="80%" />
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
